import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Container,
  CssBaseline,
  Divider,
  FormHelperText,
  Grid,
  InputAdornment,
  Pagination,
  Snackbar,
  SnackbarContent,
  styled,
  Tab,
  Tabs,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { alpha } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import DeleteIcon from "@mui/icons-material/Delete";
import PropTypes from "prop-types";
import axios from "axios";
import { NumericFormat } from "react-number-format";
import { bankCodes } from "../helper/bankCodes";
import './pemesanan2.css';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';

import LiqueModal from "../customer/components/liqueModal";
import AdminNavigation from "./adminNavigation";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { blackHex, btnStyleContrast, btnStyleOutlined, btnStyleTextContrast, discountHex, extraLightGray, grayHex, lightergrayHex, headerStyleContrast, subHeaderStyleContrast, textExtraSmallStyle, textSmallStyle, textSmallStyleContrast, textStyle, textStyleContrast } from "../helper/style";
import OrderService from "../services/manager/orderService";
import noImage from "../assets/no-image.png";
import RefundService from "../services/manager/refundService";
import dayjs from "dayjs";

const imageUrl = process.env.REACT_APP_IMAGE_URL;

const btnPaymentStyle = {
  borderRadius: "10px",
  width: "100%",
  backgroundColor: "#FE8A01",
  color: "black",
  border: "1px solid black",
  padding: 5,
  textTransform: "none",
};

const AntTabs = styled(Tabs)({
  "& .MuiTabs-indicator": {
    backgroundColor: `${blackHex} !important`, 
  },
  "& .MuiTab-root": {
    color: `${lightergrayHex} !important`,
    textTransform: "none !important", 
  },
  "& .Mui-selected": {
    color: `${blackHex} !important`, 
  },
});

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const headCells = [
  { id: "phoneNumber", numeric: false, disablePadding: false, label: "Produk" },
  { id: "updatedDate", numeric: false, disablePadding: false, label: "Tanggal Pesanan" },

  { id: "price", numeric: true, disablePadding: false, label: "Total Pesanan" },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
  {
    id: "delivery",
    numeric: false,
    disablePadding: false,
    label: "Jasa Kirim",
  },
  { id: "id", numeric: false, disablePadding: false, label: "No Pesanan" },
  { id: "action", numeric: false, disablePadding: false, label: "Aksi" },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow style={{ backgroundColor: "#FE8A01" }}>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: "1 1 100%" }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: "1 1 100%" }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Employee Data
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

function PemesananPage2() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const cleanedBackendUrl = backendUrl.replace("/backend", "");

  const [ShowSuccess, setShowSuccess] = useState(false);
  const [MsgInsert, setMsgInsert] = useState("");
  const [msgError, setMsgError] = useState("");
  const [showError, setShowError] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const [orderStatus, setOrderStatus] = useState([]);
  const [updateOrderIsLoading, setUpdateOrderIsLoading] = useState(false);
  
  const [openRefundList, setOpenRefundList] = useState(false);
  const [refundList, setRefundList] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [openAddRefund, setOpenAddRefund] = useState(false);
  const [openOrderDetail, setOpenOrderDetail] = useState(false);
  const [openConfirmationAccept, setOpenConfirmationAccept] = useState(false);
  const [loadingConfirm, setLoadingConfirm] = useState(false);

  const [formErrors, setFormErrors] = useState({});
  const [loadingAddRefund, setLoadingAddRefund] = useState(false);
  const [reason, setReason] = useState("");
  const [bank, setBank] = useState(null);
  const [accountNo, setAccountNo] = useState("");
  const [currentTab, setCurrentTab] = useState("SEMUA");

  const [search, setSearch] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalItem, setTotalItem] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [loadingTerimaPesanan, setLoadingTerimaPesanan] = useState(false);
  const [acceptIds, setAcceptIds] = useState([]);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  const handleShowError = (message) => {
    setShowError(true);
    setMsgError(message);
    setTimeout(() => {
      setShowError(false);
    }, 5000);
  }

  const handleShowSuccess = (message) => {
    setShowSuccess(true);
    setMsgInsert(message);
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  }

  const handleOpenOrderDetail = (order) => {
    setSelectedOrder(order);
    setOpenOrderDetail(true);
  }

  const handleCloseOrderDetail = (order) => {
    setOpenOrderDetail(false);
    setSelectedOrder(null);
  }

  const handleUpdatePesanan = async (e) => {
    e.preventDefault();
    try {
      setUpdateOrderIsLoading(true);
      const response = await axios.put(
        `${cleanedBackendUrl}/orders/status`
      );
      console.log(response.data);
      setShowSuccess(true);
      setMsgInsert("Berhasil Update Status Order");
      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
      // toMain();
    } catch (error) {
      console.error(error);
      setMsgError("Gagal Update Order");
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 5000);
    } finally {
      setUpdateOrderIsLoading(false);
    }
  };

  const handleNavigation = async (nav) => {
    setCurrentTab(nav);
    setSelectedStatus(nav === "SEMUA" ? "" : nav);
  };

  const printOrder = async (order) => {
    if (!order.delivery) {
      return;
    }
    try {
      const response = await axios.get(
        `${cleanedBackendUrl}/delivery/print/${order.delivery.awb}`
      );

      if (response) {
        const data = response.data[0];
        if (data.success === "true") {
          const printLink = data.rotaPrintUrl;
          // Prompt user for adjustment note
          // Build the additional notes content from order.order.itemList
          const items = order.order && order.order.itemList ? order.order.itemList : [];
          if (items.length > 0) {
            try {
              // Fetch the PDF as ArrayBuffer
              const proxyUrl = `${process.env.REACT_APP_BACKEND_URL}/proxy/pdf?url=${encodeURIComponent(printLink)}`;
              const pdfBytes = await fetch(proxyUrl).then(res => res.arrayBuffer());
              const pdfDoc = await PDFDocument.load(pdfBytes);
              // Embed font
              const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
              const pages = pdfDoc.getPages();
              const firstPage = pages[0];
              // Prepare notes section
              const notesTitle = "List Barang:";
              const itemLines = items.map(
                (item) =>
                  `- ${item.name} | Size: ${item.size ?? '-'} | Qty: ${item.quantity}`
              );
              const allLines = [notesTitle, ...itemLines];
              // Layout: leave margin from bottom, print upwards
              const fontSize = 6;
              const lineHeight = fontSize + 2;
              const marginBottom = 90;
              // Calculate Y so all lines fit above the margin
              allLines.forEach((line, i) => {
                firstPage.drawText(line, {
                  x: 47,
                  y: marginBottom + (allLines.length - i - 1) * lineHeight,
                  size: fontSize,
                  font,
                  color: rgb(0, 0, 0),
                });
              });
              const modifiedPdfBytes = await pdfDoc.save();
              const blob = new Blob([modifiedPdfBytes], { type: 'application/pdf' });
              const url = URL.createObjectURL(blob);
              window.open(url, '_blank');
            } catch (e) {
              alert('Gagal menambahkan catatan ke PDF. Membuka file asli.');
              window.open(printLink, '_blank');
            }
          } else {
            window.open(printLink, '_blank');
          }
          fetchOrders();
        } else {
          switch(data.reason) {
            case "S28":
              handleShowError("AWB has been cancelled");
              break;
            case "S32":
              handleShowError("AWB has been completed or returned");
              break;
            default:
              handleShowError("Oops, something went wrong");
              break;
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  }


  const printOrderByStatus = async () => {
    try {
      const response = await axios.get(
        `${cleanedBackendUrl}/delivery/print/status/${currentTab}`
      )

      if (response) {
        const data = response.data[0];
        if (data.success === "true") {
          const printLink = data.rotaPrintUrl;
          window.open(printLink, "_blank");
        } else {
          switch(data.reason) {
            case "S28":
              setMsgError("AWB has been cancelled");
              break;
            case "S32":
              setMsgError("AWB has been completed or returned");
              break;
            default:
              setMsgError("Oops, something went wrong");
              break;
          }

          
          setShowError(true);
          setTimeout(() => {
            setShowError(false);
          }, 5000);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const fetchOrders = async () => {
    try {
      const response = await OrderService.getOrderList(page, perPage, selectedStatus, search);
      if (response) {
        const data = response.data;
        setOrderData(data.orders);
        setTotalItem(data.totalItems);
        setTotalPage(data.totalPage);
      }
    } catch (error) {
      handleShowError("Gagal mendapatkan pesanan")
    }
  };

  const acceptOrder = async (order) => {
    if (order.order.status.key !== 'PAID') {
      handleShowError("Tidak bisa menerima pesanan ini karena statusnya bukan menunggu konfirmasi");
      return;
    }

    try {
      setLoadingTerimaPesanan(true);
      setAcceptIds([...acceptIds, order.order.id]);
      const response = await OrderService.acceptOrder(order.order.id, order.payment[0].referenceId);
      if (response) {
        fetchOrders();
        handleShowSuccess(`Terima pesanan sukses (ID Pesanan: ${order.order.id})`);
      }
    } catch (error) {
      const data = error.response.data;
      if (data) {
        handleShowError(data.message);
      } else {
        handleShowError("Gagal menerima pesanan");
      }
    } finally {
      setLoadingTerimaPesanan(false);
      setAcceptIds(acceptIds.filter(id => id !== order.order.id));
    }
  }

  const acceptAllOrder = async () => {
    try {
      setLoadingConfirm(true);
      const response = await OrderService.acceptAllOrder(selectedStatus);
      if (response) {
        handleShowSuccess("Berhasil menerima semua pesanan");
      }
    } catch (error) {
      const data = error.response.data;
      if (data) {
        handleShowError(data.message);
      } else {
        handleShowError("Gagal menerima pesanan");
      }
    } finally {
      setLoadingConfirm(false);
      fetchOrders();
    }
  }

  const fetchStatus = async () => {
    try {
      const response = await axios.get(`${cleanedBackendUrl}/orders/status`);
      setOrderStatus(response.data.orderStatusList);
    } catch (error) {
      console.error(
        "Error fetching order list:",
        error.response.data.orderList
      );
    }
  };

  useEffect(() => {
    fetchOrders();
    fetchStatus();
  }, []);

  const getStatusColor = (key) => {
    let bg = ''
    let text = ''
  
    if (key === 'DRAFT') {
      text = grayHex
      bg = extraLightGray
    } else if (key === 'WAITING_FOR_PAYMENT') {
      text = '#C4B105'
      bg = '#FFFEF7' // very dark orange-brown
    } else if (key === 'PAID') {
      text = '#2088EF'
      bg = '#ECF2F8' // dark steel blue
    } else if (key === 'PACKAGED') {
      text = '#F48802'
      bg = '#FEF8F0' // navy tone
    } else if (key === 'ON_DELIVERY') {
      text = '#2088EF'
      bg = '#F7FBFE' // deep purple
    } else if (key === 'DELIVERED') {
      text = '#08B96A'
      bg = '#EFFDF7' // forest green
    } else if (key === 'CANCELED') {
      text = '#F36464'
      bg = '#FEF5F5' // blood red
    }
  
    return {
      background: bg,
      color: text
    }
  };

  const getStatusText = (key) => {
    let text = ''
    if (key === 'DRAFT') {
      text = 'Dalam Keranjang'
    } else if (key === 'WAITING_FOR_PAYMENT') {
      text = 'Belum Bayar'
    } else if (key === 'PAID') {
      text = 'Menunggu Konfirmasi'
    } else if (key === 'PACKAGED') {
      text = 'Diproses'
    } else if (key === 'ON_DELIVERY') {
      text = 'Dikirim'
    } else if (key === 'DELIVERED') {
      text = 'Selesai'
    } else if (key === 'CANCELED') {
      text = 'Dibatalkan/Refund'
    }
  
    return text;
  };

  const getPembayaran = (method, channel) => {
    if (method === 'CASH_ON_DELIVERY') {
      return "COD";
    } else {
      switch (channel) {
        case 'QRIS':
          return "QRIS";
        case 'OVO':
          return "OVO";
        case 'DANA':
          return "Dana";
        case 'MANDIRI':
          return "Mandiri Virtual Account";
        case 'BRI':
          return "BRI Virtual Account";
        case 'BNI':
          return "BNI Virtual Account";
        case 'CIMB':
          return "CIMB Virtual Account";
        case 'PERMATA':
          return "Permata Virtual Account";
        case 'SAHABAT_SAMPOERNA':
          return "Sahabat Sampoerna Virtual Account";
        case 'BJB':
          return "BJB Virtual Account";
        case 'BSI':
          return "BSI Virtual Account";
        default:
          return "";
      }
    }
  };

  const validate = () => {
    let tempErrors = {};
    if (!reason) {
      tempErrors.reason = "Alasan refund harus diisi";
    }

    if (!bank) {
      tempErrors.bank = "Bank/E-Wallet Tujuan harus diisi"
    }

    if (!accountNo) {
      tempErrors.accountNo = "No. Rekening / HP harus diisi"
    }

    setFormErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleOpenRefundList = (order) => {
    setSelectedOrder(order)
    setRefundList(order.refund);
    setOpenRefundList(true);
  }

  const handleCloseRefundList = () => {
    setOpenRefundList(false);
    setRefundList([]);
  }

  const handleCloseAddRefund = () => {
    setOpenAddRefund(false);
    setReason("");
    setBank(null);
    setAccountNo("");
  }

  const handleAddRefund = async (e) => {
    e.preventDefault();
    if(validate()) {
      try {
        if (selectedOrder.payment.length <= 0) {
          return;
        }

        setLoadingAddRefund(true);
        const response = await RefundService.createRefundAdmin(
          selectedOrder.order.id,
          selectedOrder.order.username,
          selectedOrder.payment[0].referenceId,
          reason,
          accountNo,
          bank?.bankCode
        );
  
        if (response) {
          handleShowSuccess("Berhasil melakukan refund");
  
          setLoadingAddRefund(false);
          handleCloseAddRefund();
          handleCloseRefundList();
          fetchOrders();
        }
      } catch (error) {
        handleShowError("Gagal membuat refund");
      } finally {
        setLoadingAddRefund(false);
      }
    } else {
      console.log(formErrors)
    }
  }

  const searchTimeout = useRef(null);
  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      setPage(1);
      fetchOrders()
    }, 500);
    return () => clearTimeout(searchTimeout.current);
  }, [search]);

  useEffect(() => {
    fetchOrders();
    window.scrollTo(0, 0);
  }, [page]);

  useEffect(() => {
    setPage(1);
    fetchOrders();
  }, [selectedStatus]);

  return (
    <Box>
      <CssBaseline />
      <AdminNavigation />
      <Container
        component="main"
        maxWidth="xl"
      >
        
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={ShowSuccess}
          autoHideDuration={3000}
          onClose={() => setShowSuccess(false)}
        >
          <SnackbarContent
            sx={{ backgroundColor: "#19B600" }} 
            message={MsgInsert}/>
        </Snackbar>
  
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={showError}
          autoHideDuration={3000}
          onClose={() => setShowError(false)}
        >
          <SnackbarContent 
            sx={{ backgroundColor: "#E50B0B" }} 
            message={msgError}/>
        </Snackbar>
        
        <Grid container spacing={1} alignItems="center" marginBottom={2}>
          <Grid item xs={12} md={6}>
            <Typography sx={{ ...headerStyleContrast }}>
              Review Pesanan
            </Typography>
          </Grid>
          <Grid item xs={12} sm={8} md={4}>
            <TextField
              fullWidth
              value={search}
              placeholder="Cari pesanan..."
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{ 
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchOutlinedIcon />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Button
              sx={{ ...btnStyleContrast, borderRadius: "50px", width: "100%" }} 
              onClick={handleUpdatePesanan} 
              endIcon={<EditOutlinedIcon sx={{ color: "white" }} />}
            >
              {updateOrderIsLoading ? (
                <>
                  <CircularProgress size={24} color="inherit" />{" "}
                  Loading...
                </>
              ) : (
                <div>Update Order Status</div>
              )}
            </Button>
          </Grid>
        </Grid>
        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              paddingTop: "24px",
            }}
          >
            <AntTabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              textColor="secondary"
              indicatorColor="secondary"
            >
              <Tab label={`Semua Pesanan`} {...a11yProps(0)} 
                onClick={() => handleNavigation("SEMUA")} />
              {
                orderStatus.filter((status) => status.key !== 'DRAFT').map((status, index) => (
                  <Tab key={status.key} label={getStatusText(status.key)} {...a11yProps(index + 1)}
                    onClick={() => handleNavigation(status.key)} />
                ))
              }
            </AntTabs>
          </Box>

          {
            currentTab === "PAID" && (
              <Grid container marginTop={2} justifyContent="end">
                <Grid item xs={6} md={2}>
                  <Button 
                    style={{ ...btnStyleContrast, borderRadius: "50px", width: "100%" }}
                    onClick={() => setOpenConfirmationAccept(true)}>
                    Terima Semua Pesanan
                  </Button>
                </Grid>
              </Grid>
            )
          }

          <Box sx={{ marginTop: "20px", width: "100%" }} marginBottom={3}>
            {
              orderData.map(order => (
                <Box  
                  key={order.order.id}
                  sx={{ background: "white", borderRadius: "16px", padding: "16px", marginBottom: "20px", boxShadow: "2px 2px 10px rgba(0, 0, 0, .2)" }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} display="flex" gap="20px" alignItems="center" flexWrap="wrap">
                      <Typography sx={{ ...textStyleContrast, color: lightergrayHex }} display="flex" alignItems="center" gap="10px">
                        <CalendarTodayOutlinedIcon /> <span>Dipesan Pada, {order.order.createdDate}</span>
                      </Typography>
                      {" • "}
                      <Typography sx={{ ...textStyleContrast }}>
                        {order.order.id}
                      </Typography>
                      {" • "}
                      <Typography sx={{ ...textStyleContrast }} display="flex" alignItems="center" gap="10px">
                        <PersonOutlineIcon /> <span>{order.order.username}</span>
                      </Typography>
                      {" • "}
                      <Chip 
                        sx={{ ...textExtraSmallStyle, height: "25px" }}
                        label={getStatusText(order.order.status?.key)} 
                        style={getStatusColor(order.order.status?.key)}
                      ></Chip>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} marginTop={1}>
                    <Grid item xs={12} md={6}>
                      {
                        order.order.itemList.map(item => (
                          <Box display="flex" gap={2}>
                            <Box sx={{ width: { xs: "50px", md: "100px"} }}>
                              <img
                                src={
                                  item.images?.length <= 0 || item.images == null
                                  ? noImage
                                  : `${imageUrl}${item.images[0]}`
                                }
                                alt={item.name}
                                style={{
                                  width: "100%",
                                  aspectRatio: "1 / 1",
                                  objectFit: "cover",
                                  marginRight: "3%",
                                  borderRadius: "8px"
                                }}
                              ></img>
                            </Box>
                            <Box>
                              <Typography sx={{ ...textStyleContrast, fontWeight: 500 }}>
                                {item.name}
                              </Typography>
                              <Typography sx={{ ...textSmallStyleContrast, color: lightergrayHex }}>
                                Size {item.variant?.size} {" • "} {item.quantity} x {" "}
                                <NumericFormat 
                                  value={item.price - item.discountValue} 
                                  displayType={"text"} 
                                  thousandSeparator="." 
                                  decimalSeparator=","
                                  prefix={"RP "} />
                              </Typography>
                              {
                                item.useDiscount && (
                                  <Box display="flex" gap="10px" alignItems="center">
                                    <Typography sx={{ ...textSmallStyleContrast, color: lightergrayHex, textDecoration: "line-through" }}>
                                      <NumericFormat
                                        value={item.price}
                                        displayType={"text"}
                                        thousandSeparator="."
                                        decimalSeparator=","
                                        prefix={"Rp. "}
                                      />
                                    </Typography>
                                    <Box sx={{ background: discountHex, padding: "2px 5px" }}>
                                      <Typography sx={{ ...textSmallStyle }}>
                                        <NumericFormat
                                          value={item.discountPercent}
                                          displayType={"text"}
                                          thousandSeparator="."
                                          decimalSeparator=","
                                          suffix='%'
                                        />
                                      </Typography>
                                    </Box>
                                  </Box>
                                )
                              }
                            </Box>
                          </Box>
                        ))
                      }
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Grid container spacing={2}>
                        <Grid item xs={6} md={12}>
                            <Typography sx={{ ...textSmallStyleContrast }} marginBottom={0.5}>
                              Alamat
                            </Typography>
                            <Typography sx={{ ...textStyleContrast, fontWeight: "500" }}>
                              {
                                order.payment.length > 0 ? (
                                  <>
                                    {order.payment[0]?.address?.detail}, {order.payment[0]?.address?.neighborhood}, {" "}
                                    {order.payment[0]?.address?.subdistrict}, <br/> {order.payment[0]?.address?.district}, {" "}
                                    {order.payment[0]?.address?.province}, {order.payment[0]?.address?.zipCode}
                                  </>
                                ) : (
                                  <>-</>
                                )
                              }
                            </Typography>
                        </Grid>
                        <Grid item xs={6} md={12}>
                          <Typography sx={{ ...textSmallStyleContrast }} marginBottom={0.5}>
                            No HP
                          </Typography>
                          <Typography sx={{ ...textStyleContrast, fontWeight: "500" }}>
                            {order.order.phoneNumber}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Grid container spacing={2}>
                        <Grid item xs={6} md={12}>
                          <Typography sx={{ ...textSmallStyleContrast }} marginBottom={0.5}>
                            Kurir
                          </Typography>
                          <Typography sx={{ ...textStyleContrast, fontWeight: "500" }}>
                            J&T - Reguler
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={12}>
                          <Typography sx={{ ...textSmallStyleContrast }} marginBottom={0.5}>
                            No Resi
                          </Typography>
                          <Typography sx={{ ...textStyleContrast, fontWeight: "500" }}>
                            {order.delivery ? (order.delivery.awb || "-") : "-" }
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={12}>
                          <Typography sx={{ ...textSmallStyleContrast }} marginBottom={0.5}>
                            Metode Pembayaran
                          </Typography>
                          <Typography sx={{ ...textStyleContrast, fontWeight: "500" }}>
                            {
                              order.payment.length > 0 
                                ? `${getPembayaran(order.payment[0].method, order.payment[0].channel)}`
                                : "-"
                            }
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Box marginTop={2} 
                    sx={{ 
                      cursor: "pointer" 
                    }}
                    onClick={() => handleOpenOrderDetail(order)}
                  >
                    <Grid container alignItems="center">
                      <Grid item xs={6}>
                        <Typography sx={{ ...textStyleContrast }}>
                          Total Penjualan
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography sx={{ ...textStyleContrast, fontWeight: "bold" }} 
                          display="flex" justifyContent="end"  alignItems="center"
                        >
                          <NumericFormat
                            value={order.order.subTotal}
                            displayType={"text"}
                            thousandSeparator="."
                            decimalSeparator=","
                            prefix={"RP "}
                          />
                          
                          <ArrowForwardIosIcon sx={{ marginLeft: "10px" }} />
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>

                  <Grid container marginTop={1} justifyContent="end" spacing={1}>
                    {
                      ['PACKAGED', 'ON_DELIVERY'].includes(order.order.status.key) && (
                        <Grid item xs={6} md={2}>
                          <Button sx={order.delivery?.printStatus ? { ...btnStyleTextContrast} : { ...btnStyleContrast, borderRadius: "50px" }} 
                            onClick={() => printOrder(order)} fullWidth
                          >
                            {order.delivery?.printStatus ? 'Resi Sudah Dicetak' : 'Cetak Resi'}
                          </Button>
                        </Grid>
                      )
                    }
                    {
                      order.order.status.key === 'PAID' && (
                        <Grid item xs={6} md={2}>
                          <Button sx={{ ...btnStyleContrast, borderRadius: "50px" }} 
                            onClick={() => acceptOrder(order)} fullWidth
                            disabled={acceptIds.includes(order.order.id)}
                          >
                            { acceptIds.includes(order.order.id) ? "Mohon menunggu..." : "Terima Pesanan"}
                          </Button>
                        </Grid>
                      )
                    }
                    {
                      ['PAID', 'PACKAGED'].includes(order.order.status.key) && (
                        <Grid item xs={6} md={2}>
                          <Button sx={{ ...btnStyleOutlined, color: "red", borderRadius: "50px" }} 
                            onClick={() => handleOpenRefundList(order)} fullWidth
                          >
                            Refund
                          </Button>
                        </Grid>
                      )
                    }
                  </Grid>
                </Box>
              ))
            }

            <Box display="flex" justifyContent="center">
              <Pagination sx={{ 
                  '& .MuiPaginationItem-root': {
                    color: 'black', 
                  },
                  '& .MuiPaginationItem-icon': {
                    color: 'black', 
                  },
                  '& .Mui-selected': {
                    backgroundColor: 'black !important', 
                    color: 'white', 
                  },
                }} 
                size="small"
                count={totalPage} 
                page={page}
                onChange={(_event, page) => setPage(page)} />
            </Box>  
          </Box>
        </Box>
      </Container>

      <LiqueModal open={openRefundList} onClose={handleCloseRefundList}>
        <Box>
          <Typography id="spring-modal-title" variant="h6" component="h2">
            Daftar Refund
          </Typography>
          <Grid container justifyContent="center">
            {
              refundList.map(refund => (
                <Grid item xs={12} sx={{ marginBottom: "20px" }}>
                  <Card sx={{ width: "100%", background: "#000", color: "#fff" }}>
                    <CardContent>
                      <Typography variant="h6">
                        Informasi Refund
                      </Typography>
                      <Grid container rowSpacing={1}>
                        <Grid item xs={4}>
                          No. Refund
                        </Grid>
                        <Grid item xs={8}>
                          <b>{ refund.referenceId }</b>
                        </Grid>

                        <Grid item xs={4}>
                          Alasan Refund
                        </Grid>
                        <Grid item xs={8}>
                          <b>{ refund.reason }</b>
                        </Grid>

                        <Grid item xs={4}>
                          Bank / E-Wallet
                        </Grid>
                        <Grid item xs={8}>
                          <b>{ bankCodes.find(bank => bank.bankCode === refund.bankCode)?.name }</b>
                        </Grid>

                        <Grid item xs={4}>
                          No. Rekening / HP
                        </Grid>
                        <Grid item xs={8}>
                          <b>{ refund.accountNumber }</b>
                        </Grid>

                        <Grid item xs={4}>
                          Status
                        </Grid>
                        <Grid item xs={8}>
                          <b>{ refund.status }</b>
                        </Grid>

                        <Grid item xs={4}>
                          Tanggal Permohonan
                        </Grid>
                        <Grid item xs={8}>
                          <b>{ refund.requestDate ? dayjs(refund.requestDate).format("YYYY-MM-DD HH:mm") : '-' }</b>
                        </Grid>

                        {
                          refund.status === 'REJECTED' && (
                            <>
                              <Grid item xs={4}>
                                Alasan Penolakan
                              </Grid>
                              <Grid item xs={8}>
                                { refund.rejectReason }
                              </Grid>
        
                              <Grid item xs={4}>
                                Tanggal Penolakan
                              </Grid>
                              <Grid item xs={8}>
                                { refund.acceptedDate ? dayjs(refund.acceptedDate).format("YYYY-MM-DD HH:mm") : '-' }
                              </Grid>
                            </>
                          )
                        }
        
                        {
                          !['WAITING', 'REJECTED'].includes(refund.status) && (
                            <>
                              <Grid item xs={4}>
                                Tanggal Disetujui
                              </Grid>
                              <Grid item xs={8}>
                                { refund.acceptedDate ? dayjs(refund.acceptedDate).format("YYYY-MM-DD HH:mm") : '-' }
                              </Grid>
                              
                              <Grid item xs={4}>
                                Tanggal Selesai
                              </Grid>
                              <Grid item xs={8}>
                                { refund.completeDate ? dayjs(refund.completeDate).format("YYYY-MM-DD HH:mm") : '-' }
                              </Grid>
                            </>
                          )
                        }
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            }
            {
              refundList.length === 0 && (
                <Grid item xs={12} sx={{ textAlign: "center", marginBottom: "20px" }}>
                  <Typography variant="p">
                    Belum ada data refund
                  </Typography>
                </Grid>
              )
            }
            {
              ( (refundList.length === 0 || ["REJECTED", "FAILED"].includes(refundList[0]?.status)) && ['PAID', 'PACKAGED'].includes(selectedOrder?.order?.status?.key) )
                && (
                  <Grid item xs={6}>
                    <Button onClick={() => setOpenAddRefund(true)} style={btnPaymentStyle}>Add Refund</Button>
                  </Grid>
                )
            }
          </Grid>
        </Box>
      </LiqueModal>

      <LiqueModal open={openAddRefund} onClose={handleCloseAddRefund}>
        <Box>
          <Typography id="spring-modal-title" variant="h6" component="h2">
            Request Refund
          </Typography>
          <form>
            <Grid container spacing={1} marginTop={2}>
              <Grid item xs={12}>
                <Typography>Bank Tujuan *</Typography>
                <Autocomplete 
                  options={bankCodes}
                  getOptionLabel={(option) => `${option.name} (${option.type})`}
                  value={bank ? {...bank} : null}
                  isOptionEqualToValue={(option, value) => {
                    return option.bankCode === value.bankCode
                  }}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth />
                  )}
                  onChange={(event, newValue) => setBank(newValue)} />
                {!!formErrors.bank ? (
                  <FormHelperText sx={{ color: "red" }}>
                    {formErrors.bank}
                  </FormHelperText>
                ) : null}
              </Grid>
              <Grid item xs={12}>
                <Typography>No Rekening / HP *</Typography>
                <TextField
                  fullWidth
                  value={accountNo}
                  error={!!formErrors.accountNo}
                  helperText={formErrors.accountNo}
                  FormHelperTextProps={{ sx: { color: "red" } }}
                  onChange={(e) => setAccountNo(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} spacing={1}>
                <Typography>Alasan Refund *</Typography>
                <TextareaAutosize
                  style={{ width: '100%' }}
                  minRows={3}
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                />
                {!!formErrors.reason ? (
                  <FormHelperText sx={{ color: "red" }}>
                    {formErrors.reason}
                  </FormHelperText>
                ) : null}
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  onClick={handleAddRefund}
                  fullWidth
                  disabled={loadingAddRefund}
                  style={{ backgroundColor: "black", color: "white" }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </LiqueModal>

      <LiqueModal open={openOrderDetail} onClose={handleCloseOrderDetail} width="600px">
        <Grid container rowSpacing={1}>
          <Grid item xs={12} marginBottom={3}>
            <Typography sx={{ ...subHeaderStyleContrast, fontWeight: "bold" }}>
              Total Penjualan
            </Typography>
          </Grid>
          {
            selectedOrder && (
              <>
                <Grid item xs={6}>
                  <Typography sx={{ ...textStyleContrast, color: lightergrayHex }}>
                    Total Pesanan
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="end">
                  <Typography sx={{ ...textStyleContrast }}>
                    <NumericFormat
                        value={selectedOrder.order.price}
                        displayType={"text"}
                        thousandSeparator="."
                        decimalSeparator=","
                        prefix={"RP "}
                    />
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ ...textStyleContrast, color: lightergrayHex }}>
                    Ongkos Kirim
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="end">
                  <Typography sx={{ ...textStyleContrast }}>
                    <NumericFormat
                        value={selectedOrder.order.paymentDeliveryFee}
                        displayType={"text"}
                        thousandSeparator="."
                        decimalSeparator=","
                        prefix={"RP "}
                    />
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ ...textStyleContrast, color: lightergrayHex }}>
                    Diskon
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="end">
                  <Typography sx={{ ...textStyleContrast }}>
                    <NumericFormat
                        value={selectedOrder.order.discount || 0}
                        displayType={"text"}
                        thousandSeparator="."
                        decimalSeparator=","
                        prefix={(selectedOrder.order.discount || 0) <= 0 ? "RP " : "-RP "}
                        allowNegative={false}
                    />
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ ...textStyleContrast, color: lightergrayHex }}>
                    Biaya Admin
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="end">
                  <Typography sx={{ ...textStyleContrast }}>
                    <NumericFormat
                        value={selectedOrder.order.paymentTransactionFee}
                        displayType={"text"}
                        thousandSeparator="."
                        decimalSeparator=","
                        prefix={"RP "}
                    />
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ ...textStyleContrast, fontWeight: "bold" }}>
                    Total Penjualan
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="end">
                  <Typography sx={{ ...textStyleContrast, fontWeight: "bold" }}>
                    <NumericFormat
                        value={selectedOrder.order.subTotal}
                        displayType={"text"}
                        thousandSeparator="."
                        decimalSeparator=","
                        prefix={"RP "}
                    />
                  </Typography>
                </Grid>
              </>
            )
          }
        </Grid>
      </LiqueModal>

      <LiqueModal open={openConfirmationAccept} onClose={() => setOpenConfirmationAccept(false)} width="600px">
        <Box textAlign="center">
          <Typography id="spring-modal-title" variant="h6" component="h2">
            Apakah kamu yakin ingin menerima semua pesanan?
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Button variant="outlined" onClick={() => setOpenConfirmationAccept(false)}>
              Batal
            </Button>
            <Button
              variant="outlined"
              onClick={acceptAllOrder}
              sx={{ ml: 2, backgroundColor: "black", color: "white" }}
              disabled={loadingConfirm}
            >
              {loadingConfirm ? 'Mohon menunggu...' : 'Terima Pesanan'}
            </Button>
          </Box>
        </Box>
      </LiqueModal>
    </Box>
  );
}

export default PemesananPage2;
